import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";


import { useNavigate } from "@tanstack/react-router";
import { TicketIcon } from "lucide-react";
import { useCreateCouponMutation } from "../api/queries";
import { CouponForm } from "../ui/CouponForm";

export function CouponCreatePage() {
  const nav = useNavigate({ from: "/app/loyalty/promotions/coupons/create" });
  const createCoupon = useCreateCouponMutation();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ຄູປອງ",
              to: "/app/loyalty/promotions/coupons",
            },
            {
              label: "ສ້າງຄູປອງ",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-4">
          <h2 className="flex items-center gap-2 font-bold text-2xl tracking-tight">
            <TicketIcon className="size-5" />
            ສ້າງຄູປອງ
          </h2>
        </div>

        <CouponForm
          onSubmit={async (payload) => {
            try {
              await createCoupon.mutateAsync(payload);
              toast.success("ສ້າງຄູປອງແລ້ວ");
              nav({ to: "/app/loyalty/promotions/coupons" });
            } catch (error) {
              const message =
                error instanceof Error
                  ? error.message
                  : "ສ້າງຄູປອງລົ້ມເຫຼວ";
              toast.error(message);
            }
          }}
          submitting={createCoupon.isPending}
          onCancel={() => nav({ to: "/app/loyalty/promotions/coupons" })}
          submitLabel="ສ້າງຄູປອງ"
        />
      </Main>
    </>
  );
}
